import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { SimpleProduct } from 'app/models/product/product/simple-product';
import { SiteSettings } from 'app/pages/settings/settings-page/site-settings';
import { CartService } from 'app/services/cart/cart.service';
import { ProductService } from 'app/services/product/product.service';
import { StringCleanUtils } from 'app/shared/string-clean.utils';
import { SelectItem } from 'primeng/api';
import { Observer } from 'rxjs';


@Component({
  selector: 'ultra-products-list',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})
export class ProductsListComponent implements OnInit, OnDestroy {

  // Armazena todos os produtos/Produtos da categoria retornados pelo servidor
  products: any;

  // Armazena TODOS os produtos
  databaseProducts: any;

  // Armazena os produtos filtrados
  filteredProducts = [];

  // Armazena os produtos exibidos na tela
  pagedProducts: any = [];

  sortOptions: SelectItem[];
  sortOrder: number = 2;
  sortField: string;
  obs: Observer<Params>;
  totalSize: number;
  styleConfig = { backgroundColor: '#00569a', color: '#ffffff' };
  screenConfig: ScreenConfig;
  startRows: number = 0;
  pageSize: number = 24;
  category: { id: number, name: String } = { id: null, name: null };
  hasFilter: boolean = false;
  firstLoading: boolean = false;
  newSearchLoading: boolean = false;
  currentFilter: string = '';
  currentPage: number;
  currentCategory: number;
  siteSettings = SiteSettings.getInstance();

  constructor(
    private _productService: ProductService,
    private cartService: CartService,
    private route: ActivatedRoute,
    private router: Router,
    private _toastrService: NbToastrService
  ) {
    route.queryParams.subscribe(param => {
      this.hasFilter = false;
      this.pagedProducts = [];
      this.filteredProducts = [];
      this.loadScreenConfig(param.category);
      this.startRows = this.screenConfig.currentFirst;
      this.firstLoading = true;
      this.filter(param.category, param.filter);
    });
  }

  filter(categoryId?: number, filterBy?: string, isNewSearch: boolean = true) {
    let itemPromise;

    if (categoryId !== this.currentCategory) {
      this.currentCategory = -1;
      this.currentPage = 1;
    }

    if (filterBy && filterBy != null) {
      this.hasFilter = true;
      this.currentFilter = filterBy;
      itemPromise = this._productService.find(this.currentPage ?? 1, this.currentFilter, this.sortOrder);
    }
    else if (!categoryId) {
      itemPromise = this._productService.getAll(this.currentPage ?? 1, this.sortOrder);
    } else if (categoryId) {
      this.currentCategory = categoryId;
      if (categoryId.toString() != '-99')
        itemPromise = this._productService.getProductsByCategory(categoryId, this.currentPage ?? 1, this.sortOrder);
      else
        itemPromise = this._productService.getOffers(this.currentPage ?? 1, this.sortOrder);
    }

    this.newSearchLoading = isNewSearch;
    itemPromise.subscribe((value: any) => {
      if (value.data[0]?.products != undefined) {
        this.pagedProducts = value.data[0].products.map(e => SimpleProduct.fromJson(e));

        this.category.name = StringCleanUtils.titleize(value?.data[0]?.DESCRIPTION ?? (this.hasFilter ? `Buscando por \"${this.currentFilter}\"` : 'Todos os Produtos'));
        this.category.id = (value?.data[0]?.ID ?? -1);
      } else {
        this.pagedProducts = value.data.map(e => SimpleProduct.fromJson(e));
        this.category.name = '';
        this.category.id = undefined;
      }

      this.totalSize = value.message;
      this.finishLoading();
    }, (error) => {
      this._toastrService.danger('Falha ao buscar listagem de produtos', 'Erro');
      this.finishLoading();
    })
  }

  finishLoading(): void {
    this.firstLoading = false;
    this.newSearchLoading = false;
  }

  loadScreenConfig(newCategory) {
    this.screenConfig = JSON.parse(sessionStorage.getItem('screenConfig'));
    if (this.screenConfig === null || this.screenConfig.currentCategory !== newCategory) {
      this.screenConfig = {
        currentCategory: newCategory,
        currentFilter: '',
        currentFirst: 0,
        currentSort: { label: 'Alfabética A-Z', value: 'name' },
      };
      this.saveScreenConfig();
    }
  }

  saveScreenConfig() {
    if (this.screenConfig)
      sessionStorage.setItem('screenConfig', JSON.stringify(this.screenConfig));
  }

  ngOnInit() {
    let config = this.siteSettings.getConfiguration();
    if (config.background.length > 0) {
      this.styleConfig.backgroundColor = config.background;
    }
    if (config.color.length > 0) {
      this.styleConfig.color = config.color;
    }
  }

  ngOnDestroy(): void {
    this.saveScreenConfig();
  }

  // Ajusta as quantidades dos itens da lista conforme o que consta no carrinho
  adjustQuantityInProduct() {
    for (let y = 0; y <= this.products.length - 1; y++) {
      this.products[y].quantity = 0;
      this.products[y].measureQuantity = 1;
      delete this.products[y].unitMeasureSelected;
      delete this.products[y].measurementUnit;
      delete this.products[y].index;
    }
    if (!JSON.parse(localStorage.getItem('cart'))) return;
    const result = JSON.parse(localStorage.getItem('cart'));
    if (result.length < 0) return;
    for (let i = 0; i <= this.products.length - 1; i++) {
      for (let x = 0; x <= result.length - 1; x++) {
        if (this.products[i].id == result[x].id) {
          this.products[i].quantity = result[x].quantity;
          this.products[i].unitMeasureSelected = result[x]?.unitMeasureSelected;
          this.products[i].measureQuantity = result[x].measureQuantity;
          this.products[i].totalPrice = result[x].totalPrice;
          if (result[x].measurementUnit) {
            this.products[i].measurementUnit = result[x].measurementUnit;
            this.products[i].index = result[x].index;
          }
        }
      }
    }
  }

  pageEvent(event) {
    this.currentPage = event.page + 1;
    this.filter(this.currentCategory, this.currentFilter, false);
  }

  sortEvent(order: number) {
    this.sortOrder = order;
    this.filter(this.currentCategory, this.currentFilter, false);
  }

  lazyLoadProduct(list: any, event: any) {
    if (list.length > 0) {
      const start = event.first; // event.first = First row offset
      const end = start + event.rows; // event.rows = Number of rows per page
      if (list.length > (end - start)) {
        list = list.slice(start, end);
      }
      this.pagedProducts = list;
    } else {
      this.pagedProducts = [];
    }
  }

  goToDetails(product: SimpleProduct) {
    this.router.navigate([`pages/products/detail`], { queryParams: { productId: product.id, clasId: product.classificationId } });
    sessionStorage.setItem('productDetails', JSON.stringify(product));
  }

  onSortChange(event) {
    const value = event.value;
    const factor = (value.indexOf('!') === 0 ? -1 : 1);

    if (value.includes('price')) {
      this.products.sort((n1, n2) => {
        if (parseFloat(n1.price) > parseFloat(n2.price)) return factor;
        if (parseFloat(n1.price) < parseFloat(n2.price)) return factor * -1;
        return 0;
      });

      this.filteredProducts.sort((n1, n2) => {
        if (parseFloat(n1.price) > parseFloat(n2.price)) return factor;
        if (parseFloat(n1.price) < parseFloat(n2.price)) return factor * -1;
        return 0;
      });
    } else {
      this.products.sort((n1, n2) => {
        if (this.clean(n1.name) > this.clean(n2.name)) return factor;
        if (this.clean(n1.name) < this.clean(n2.name)) return factor * -1;
        return 0;
      });

      this.filteredProducts.sort((n1, n2) => {
        if (this.clean(n1.name) > this.clean(n2.name)) return factor;
        if (this.clean(n1.name) < this.clean(n2.name)) return factor * -1;
        return 0;
      });
    }

    this.screenConfig.currentSort = event;
    this.saveScreenConfig();
    this.lazyLoadProduct(this.filteredProducts, { start: 0, rows: this.pageSize });

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
      return;
    }
    this.sortOrder = 1;
    this.sortField = value;
  }

  clean(word: String): string {
    return StringCleanUtils.replaceSpecialChars(word);
  }

  updateProduct(productUpdate: SimpleProduct) {
    this.cartService.updateProduct(productUpdate, null, '');
  }

  changeToNumericKeyboard() {
    const arrayInputs: any = document.getElementsByClassName('p-inputnumber-input');
    const interval = setInterval(() => {
      Array.from(arrayInputs)?.forEach(el => {
        (el as HTMLElement).setAttribute('type', 'tel');
      });
      clearInterval(interval);
    }, 100);
  }
}

class ScreenConfig {
  currentFirst: number;
  currentCategory: string;
  currentFilter: string;
  currentSort: any;
}
